import { useObserver } from 'mobx-react-lite'
import React from 'react'
import { CentricTypography } from '@core/component/CentricTypography'
import { makeStyles } from '@material-ui/core'
import PopupComponent from '@components/std-components/Popup'
import { EnhancedWarningPopupContent } from './LazyEnhancedWarningPopupContent'
import ArrowDropDown from '@material-ui/icons/ArrowDropDown'
import Icon from '@components/std-components/Icons'
import { WarningLogo } from '@resources/images'
import { WANING_DROPDOWN_DEFAULT_OPTION } from '@modules/order/constants/uiConstants'

const useStyle = makeStyles(theme => ({
  container: {
    height: 30,
    maxWidth: 200,
    minWidth: 115,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer'
  },
  warningIcon: {
    margin: '0 5px'
  },
  warningText: {
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}))

export default function EnhancedWarningDropdown({
  popupProps,
  warningProps
}): JSX.Element {
  return useObserver(function useHook() {
    const classes = useStyle()
    const { warningOptions, ...rest } = warningProps
    const updatedWarningOptions = [...warningOptions, ...WANING_DROPDOWN_DEFAULT_OPTION]
    const warnings = warningProps?.appliedWarningFilterOption
    const selectedOptionText = warnings?.displayName
      ? `${warnings?.displayName}`
      : 'Select Filters...'
    return (
      <PopupComponent
        trigger={
          <div className={classes.container}>
            <Icon
              imageSrc={WarningLogo}
              alt={'warningIcon'}
              className={classes.warningIcon}
            />
            <CentricTypography variant='caption' className={classes.warningText}>
              {selectedOptionText}
            </CentricTypography>
            {warnings?.count ? (
              <CentricTypography variant='caption'>
                {`(${warnings?.count || 0})`}
              </CentricTypography>
            ) : null}
            <ArrowDropDown />
          </div>
        }
        arrow={false}
        contentStyle={{
          width: 'fit-content',
          padding: 10
        }}
        {...popupProps}
      >
        <EnhancedWarningPopupContent warningOptions={updatedWarningOptions} {...rest} />
      </PopupComponent>
    )
  })
}
